import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// Components
import {Button} from '@betareader/design-system';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// i18n
import { withTranslation } from 'react-i18next';
import { authUtil } from '../../utils';
import {
  replyToConversation,
  startConversation,
  onTypingNewMessage
} from '../../modules/message';
import autoGrow, { resetGrowth } from './autoGrowTextArea';
// styling
import './chat.css';
import {
  MAX_MESSAGE_LENGTH,
  SHOW_MESSAGE_COUNT_FROM,
  formatMessageCount
} from './messageLimits';

export class InputBar extends Component {
  constructor(props) {
    super(props);
    this.state = { text: '' };
  }

  handleMessageChange = event => {
    const { currentConversation, userProfile } = this.props;
    const value = event.target.value;
    // kept so the field can be collapsed again once the message is sent
    this.textAreaNode = event.target;
    autoGrow(this.textAreaNode);
    this.setState({
      text: value
    });
    if (value && value.length > 0) {
      this.props.onTypingNewMessage({ currentConversation: currentConversation._id, userId: userProfile._id, displayName: userProfile.displayName, isTyping: true });
    }
    if (!value) {
      this.props.onTypingNewMessage({ currentConversation: currentConversation._id, userId: userProfile._id, displayName: userProfile.displayName, isTyping: false });
    }
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 13 && (event.metaKey || event.ctrlKey)) {
      // this is a CMD+Enter or Ctrl+Enter event. Submit reply
      this.sendMessage();
    }
  }

  sendMessage = async () => {
    const {
      currentConversation, userProfile
    } = this.props;
    const { text } = this.state;
    if (!this.canSendMessage()) {
      return;
    }
    const idToken = await authUtil.getFreshIdToken();
    const onSent = (response) => {
      if (!response || !response.success) return;
      this.props.onTypingNewMessage({ currentConversation: currentConversation._id,
        userId: userProfile._id, displayName: userProfile.displayName, isTyping: false });
      // A blocked or failed request must leave the draft available for editing.
      if (this.state.text === text) {
        this.setState({text: ''});
        resetGrowth(this.textAreaNode);
      }
    };
    if (currentConversation._id) {
      // conversation exists, simply reply to it
      this.props.replyToConversation(idToken, currentConversation._id, { text }, onSent);
    } else if (currentConversation.isNew) {
      // this is just a placeholder conversation
      // start a new conversation with said user
      const conversationData = {
        subject: currentConversation.subject,
        members: currentConversation.members.map(user => user._id),
        text
      };
      // if this is a new support conversation
      if (currentConversation.type === 'support') {
        conversationData.type = 'support';
      }
      this.props.startConversation(idToken, conversationData, onSent);
    }
  }

  canSendMessage = () => {
    const { currentConversation } = this.props;
    const { text } = this.state;
    return (
      text &&
      text.length > 0 &&
      text.length <= MAX_MESSAGE_LENGTH &&
      currentConversation.members.length > 0
    );
  }

  render() {
    const { currentConversation, t, sendingMessage } = this.props;
    const { text } = this.state;
    if (currentConversation) {
      return (
        <div className='chat-input-shell'>
          <div className='inputContainer'>
            <textarea
              className='chat-input-textarea'
              aria-label={t('NewMessage')}
              rows={1}
              maxLength={MAX_MESSAGE_LENGTH}
              placeholder={t('NewMessage')}
              onKeyDown={this.handleKeyDown}
              onChange={this.handleMessageChange}
              value={text}
            />
            <Button
              className='chat-send-button'
              type='button'
              size='small'
              variant={!text ? 'secondary' : 'primary'}
              aria-busy={sendingMessage}
              disabled={!this.canSendMessage()}
              onClick={this.sendMessage}
            >{t('SendMessage')}</Button>
          </div>
          <div className='chat-input-meta'>
            <span className='chat-message-limit-hint'>
              {t('ChatMessageLimitHint')}
            </span>
            {text.length >= SHOW_MESSAGE_COUNT_FROM && (
              <span className='chat-character-count' aria-live='polite'>
                {`${formatMessageCount(text.length)} / ${formatMessageCount(
                  MAX_MESSAGE_LENGTH
                )}`}
              </span>
            )}
          </div>
        </div>
      );
    }
    return null;
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  userProfile: state.user.userProfile,
  idToken: state.user.idToken,
  conversations: state.message.conversations,
  currentConversation: state.message.currentConversation,
  sendingMessage: state.message.sendingMessage
});

const mapDispatchToProps = dispatch => bindActionCreators({
  replyToConversation,
  startConversation,
  onTypingNewMessage,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(InputBar)));
